import { ca } from '@cian/analytics';

export function trackClickDistrictRating() {
  ca('event', {
    action: 'bti_click',
    category: 'card',
    label: 'district_rating',
    name: 'oldevent',
  });
}
